import React from 'react'
import PropTypes from 'prop-types'
import Home from '../../components/Home'
import MnSenate from '../../components/Legislature/MnSenate'
import MnHouse from '../../components/Legislature/MnHouse'
import UsHouse from '../../components/Legislature/UsHouse'
import Governor from '../Governor'
import Judicial from '../Judicial'
import Statewide from '../Statewide'
import President from '../President'
import CountyIndex from '../CountyIndex'
import National from '../National'
import UsSenate from '../UsSenate'
import PresidentialPrimary from '../PresidentialPrimary'
import PresidentialPrimaryByCounty from '../PresidentialPrimaryByCounty'
import Ap from '../Ap'
import ApMnHouseDfl from '../Ap/ApMnHouseDfl'
import ApMnHouseGop from '../Ap/ApMnHouseGop'
import ApMnSenate from '../Ap/ApMnSenate'
import ApUsSenate from '../Ap/ApUsSenate'
import ApUsHouse from '../Ap/ApUsHouse'
import GenericRace from '../GenericRace'
import RaceVideo from '../GenericRace/RaceVideo'

const ComponentChooser = ({ href, title, start }) => {
  // Section frame routes arrive as `${item.href}/frame` (e.g. `us/house/frame`).
  // Strip the trailing `/frame` so they resolve to the same component as the
  // standalone route. The framed layout is handled separately in app.js by the
  // URL, not here. Leading-slash frames (`/president/frame`, `/races/frame`) map
  // to different components and keep their own cases below.
  const normalizedHref =
    !href.startsWith('/') && href.endsWith('/frame')
      ? href.slice(0, -'/frame'.length)
      : href

  switch (normalizedHref) {
    case '/':
      return <Home />
    case 'mn/senate':
      return <MnSenate />
    case 'mn/house':
      return <MnHouse />
    case 'us/house':
      return <UsHouse />
    case 'governor':
      return <Governor />
    case 'statewide':
      return <Statewide />
    case 'judicial':
      return <Judicial />
    case 'president':
      return <President />
    case 'county':
      return <CountyIndex start={start} />
    case 'national':
      return <National />
    case 'us/senate':
      return <UsSenate />
    case 'president/primary':
      return <PresidentialPrimary />
    case 'president/county':
      return <PresidentialPrimaryByCounty />
    case '/president/frame':
      return <President />
    case '/races/frame':
      return <GenericRace />
    case '/races/video':
      return <RaceVideo />
    case 'ap':
      return <Ap />
    case 'ap/mnhouse/dfl':
      return <ApMnHouseDfl />
    case 'ap/mnhouse/gop':
      return <ApMnHouseGop />
    case 'ap/mnsenate':
      return <ApMnSenate />
    case 'ap/ussenate':
      return <ApUsSenate />
    case 'ap/ushouse':
      return <ApUsHouse />

    default:
      return <DoesNotExist title={title} />
  }
}

ComponentChooser.propTypes = {
  href: PropTypes.string.isRequired,
  title: PropTypes.string,
  start: PropTypes.string,
}

const DoesNotExist = ({ title }) => {
  return (
    <div>
      <h1>{title ? title : 'Does not exist'}</h1>
      <h2>No results to show</h2>
    </div>
  )
}

DoesNotExist.propTypes = {
  title: PropTypes.string,
}

export default ComponentChooser
